import classNames from 'classnames';

import Icon from './Icon';

type File = {
  name: string;
  meta: {
    progress: number;
  };
}

type PropsFileProgress = {
  file: File;
  onRemove: (file: File) => void;
}

export function FileProgress({
  file,
  onRemove = () => {
    return false;
  }
}: PropsFileProgress) {
  return (
    <ul className="list-group list-group-flush mt-1">
      <ul className="list-group">
        <li className="list-group-item">
          <span className="btn-floating btn-fb btn-sm">
            <Icon
              icon="fa-file"
            />
          </span>
          <span className="file-name">
            {file.name}
          </span>
          <span className="float-end">
            <Icon
              onClick={() => onRemove(file)}
              icon="fa-close"
              className="btn-fb btn-sm btn-danger"
            />
          </span>
          {(file.meta && file.meta.progress < 100) && (
            <div
              className="progress"
            >
              <div
                className={
                  classNames(
                    'progress-bar progress-bar-striped progress-bar-animated',
                    { 'bg-secondary': !file.meta.progress || file.meta.progress === 100 }
                  )
                }
                role="progressbar"
                aria-valuenow={file.meta.progress}
                aria-valuemin={0}
                aria-valuemax={100}
                style={{
                  width: `${file.meta.progress || 100}%`
                }}
              >
                {file.meta.progress ? `${file.meta.progress} %` : ''}
              </div>
            </div>
          )}
        </li>
      </ul>
    </ul>

  );
}

export default FileProgress;
